<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Habilitados ({{ activeArrData.length }})">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 my-3" *ngFor="let comment of activeArrData, index as i">
        <mat-card class="has-outline-menu comment" *ngIf="comment.status === 'Activo'">
          <div class="vs-crud-menu">
            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar comentario" (click)="editComment(comment)">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                    [matTooltip]="comment.status === 'Activo' ? 'Deshabilitar Comentario' :  'Habilitar Comentario'"
                    (click)="changeStatus(comment, comment.status)">
              <mat-icon>{{ comment.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar comentario" (click)="delete(comment)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
          <mat-card-header>
            <img mat-card-avatar [src]="comment.img | safeDom">
            <mat-card-title>{{comment.title}}</mat-card-title>
            <mat-card-subtitle>{{comment.subTitle}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p>
              {{comment.information | maxLength | addQuotes}}
            </p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Deshabilitados ({{ inactiveArrData.length }})">
    <div class="row disabled-content">
      <div class="col-12 col-md-4 col-lg-3 my-3" *ngFor="let comment of inactiveArrData, index as i">
        <mat-card class="has-outline-menu comment" *ngIf="comment.status === 'Desactivado'">
          <div class="vs-crud-menu">
            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                    [matTooltip]="comment.status === 'Activo' ? 'Deshabilitar Comentario' :  'Habilitar Comentario'"
                    (click)="changeStatus(comment, comment.status)">
              <mat-icon>{{ comment.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar comentario" (click)="delete(comment)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
          <mat-card-header>
            <img mat-card-avatar [src]="comment.img | safeDom" [alt]='comment.title'
                 onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
            <mat-card-title>{{comment.title}}</mat-card-title>
            <mat-card-subtitle>{{comment.subTitle}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p>
              {{comment.information | maxLength | addQuotes}}
            </p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
